import React from "react";

import { Stack } from "@mui/material";
import { NumberInput } from "components/forms";

import { State } from "./FeesForm";

interface Props {
  values: State["static"];
  setState: React.Dispatch<React.SetStateAction<State>>;
}

export const ClassicMethod: React.FC<Props> = ({ values, setState }) => {
  const handleValueChange = ({ key, value }: { key: keyof State["static"]; value: number | null }) => {
    setState((prevState) => ({
      ...prevState,
      static: {
        ...prevState.static,
        [key]: value
      }
    }));
  };

  return (
    <Stack sx={{ gap: "20px" }}>
      <Stack sx={{ flexDirection: "row", gap: "20px" }}>
        <NumberInput
          fullWidth
          label="Cost Investment Period"
          placeholder="%"
          value={values.cost_fees_inv}
          numberInputProps={{
            decimalScale: 2,
            suffix: "%",
            onValueChange: ({ floatValue }) => handleValueChange({ key: "cost_fees_inv", value: floatValue || null })
          }}
        />
        <NumberInput
          fullWidth
          label="Commit Investment Period"
          placeholder="%"
          value={values.commitment_fees_inv}
          numberInputProps={{
            decimalScale: 2,
            suffix: "%",
            onValueChange: ({ floatValue }) =>
              handleValueChange({ key: "commitment_fees_inv", value: floatValue || null })
          }}
        />
      </Stack>
      <Stack sx={{ flexDirection: "row", gap: "20px" }}>
        <NumberInput
          fullWidth
          label="Cost Post Investment Period"
          placeholder="%"
          value={values.cost_fees_post}
          numberInputProps={{
            decimalScale: 2,
            suffix: "%",
            onValueChange: ({ floatValue }) => handleValueChange({ key: "cost_fees_post", value: floatValue || null })
          }}
        />
        <NumberInput
          fullWidth
          label="Commit Post Investment Period"
          placeholder="%"
          value={values.commitment_fees_post}
          numberInputProps={{
            decimalScale: 2,
            suffix: "%",
            onValueChange: ({ floatValue }) =>
              handleValueChange({ key: "commitment_fees_post", value: floatValue || null })
          }}
        />
      </Stack>
    </Stack>
  );
};
